export default {
  currentTimeSec: 0.0,
  userTimeSec: 0.0,
};
